export const API_URL = 'https://dizzy-toothpaste-production.up.railway.app';